var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7232 12.6738L15.0562 19.3408C14.4609 19.9361 13.4291 19.5194 13.4291 18.6662V14.8565H8.03205C7.50424 14.8565 7.07962 14.4318 7.07962 13.904V10.0943C7.07962 9.56652 7.50424 9.14189 8.03205 9.14189H13.4291V5.33218C13.4291 4.48293 14.457 4.06227 15.0562 4.65754L21.7232 11.3245C22.0923 11.6976 22.0923 12.3008 21.7232 12.6738ZM9.61943 19.1424V17.555C9.61943 17.2931 9.40513 17.0788 9.14321 17.0788H5.80971C5.1073 17.0788 4.53981 16.5113 4.53981 15.8089V8.18946C4.53981 7.48705 5.1073 6.91956 5.80971 6.91956H9.14321C9.40513 6.91956 9.61943 6.70526 9.61943 6.44334V4.85596C9.61943 4.59405 9.40513 4.37975 9.14321 4.37975H5.80971C3.70643 4.37975 2 6.08618 2 8.18946V15.8089C2 17.9122 3.70643 19.6186 5.80971 19.6186H9.14321C9.40513 19.6186 9.61943 19.4043 9.61943 19.1424Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.f326e599.svg";
export { ForwardRef as ReactComponent };